export function rem(pixels: number, baseSize = 10): string {
	return `${pixels / baseSize}rem`
}
